import Head from 'next/head';
import React from 'react';

import ProductLayout from '../../../components/ProductComp/layout';
import BundlesSection from '../../../components/ProjectHomePage/BundlesSection';
import { pageTitle } from '../../../components/shared/basic/customHead';

const ProductBundlesPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>{pageTitle('Products - Bundles')}</title>
      </Head>
      <ProductLayout>
        <div id='books'>
          <BundlesSection isPagination={true} />
        </div>
      </ProductLayout>
    </>
  );
};

export default ProductBundlesPage;
